import {
    ArrowLeftIcon,
    ArrowRightIcon,
    XMarkIcon,
} from '@heroicons/react/24/outline';

function EIcon({ type }) {
    if (type === 'left') return <ArrowLeftIcon className="h-4 w-4" />;
    if (type === 'right') return <ArrowRightIcon className="h-4 w-4" />;
    return <XMarkIcon className="h-4 w-4" />;
}

export default function EngageButtons({
    value = 'none',
    onChange,
    allowed = ['left', 'right', 'none'],
    hideUnsupported = false,
}) {
    const ALL = ['left', 'right', 'none'];
    const order = hideUnsupported
        ? ALL.filter((k) => allowed.includes(k))
        : ALL;

    return (
        <div
            className="flex flex-wrap gap-2"
            role="radiogroup"
            aria-label="Engage"
        >
            {order.map((opt) => {
                const active = value === opt;
                const disabled = !allowed.includes(opt);
                const colorClass = disabled
                    ? 'text-neutral-300'
                    : active
                    ? 'text-primary-600'
                    : 'text-neutral-500';

                return (
                    <span
                        key={opt}
                        className={[
                            'relative inline-flex rounded-xl p-[2px]',
                            disabled ? 'bg-neutral-200' : 'bg-neutral-300',
                            'transition-colors duration-300 ease-[cubic-bezier(0.22,0.61,0.36,1)]',
                            'motion-reduce:transition-none',
                        ].join(' ')}
                    >
                        <button
                            type="button"
                            role="radio"
                            aria-checked={active}
                            aria-label={`Engage ${opt}`}
                            disabled={disabled}
                            onClick={() => !disabled && onChange?.(opt)}
                            className={[
                                'inline-flex h-9 w-12 items-center justify-center rounded-[10px] bg-white',
                                'transition-[opacity,box-shadow] duration-300 ease-[cubic-bezier(0.22,0.61,0.36,1)]',
                                'motion-reduce:transition-none',
                                'shadow-sm',
                                !disabled && 'hover:shadow',
                                disabled && 'cursor-default opacity-50',
                                active
                                    ? 'ring-2 ring-primary-600 ring-offset-1 ring-offset-white'
                                    : 'ring-2 ring-neutral-200',
                                'focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-1',
                                colorClass,
                            ].join(' ')}
                            title={`Engage ${opt}`}
                        >
                            <EIcon type={opt} />
                        </button>
                    </span>
                );
            })}
        </div>
    );
}
